import { render, staticRenderFns } from "./topController.vue?vue&type=template&id=6d89ab02&scoped=true&"
import script from "./topController.vue?vue&type=script&lang=js&"
export * from "./topController.vue?vue&type=script&lang=js&"
import style0 from "./topController.vue?vue&type=style&index=0&id=6d89ab02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d89ab02",
  null
  
)

export default component.exports